import { FINDING_CATEGORIES } from "./FINDING_CATEGORIES";
import type { Finding, FindingCategory } from "./Finding";
import { sectionSeverity } from "./sectionSeverity";
import { selectFixFirst } from "./selectFixFirst";
import { SEVERITY_RANK } from "./SEVERITY_RANK";

// Секция, открытая по умолчанию: та, где главная ошибка матча (`selectFixFirst`), — подробности
// к «Главному» сразу под рукой. Главной нет — категория с худшей оценкой (`sectionSeverity`),
// при равенстве первая по порядку; ошибок нет нигде — первая категория.
export const defaultSection = (findings: readonly Finding[]): FindingCategory => {
  const [main] = selectFixFirst(findings);
  if (main !== undefined) {
    return main.category;
  }
  return FINDING_CATEGORIES.reduce((best, category) =>
    SEVERITY_RANK[sectionSeverity(findings, category)] >
    SEVERITY_RANK[sectionSeverity(findings, best)]
      ? category
      : best,
  );
};
